import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/about_banner.png';
import _imports_1 from '../../assets/img/public_gy_logo_bg.png';
import _imports_2 from '../../assets/img/wogongyi.png';
const _withScopeId = n => (_pushScopeId("data-v-217fd8c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "web-banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "banner-word flex align-items"
}, [/*#__PURE__*/_createElementVNode("h3", null, "爱沃客"), /*#__PURE__*/_createElementVNode("h4", null, "IWOWKE")])], -1));
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"WO-welfare\" data-v-217fd8c2><div class=\"welfare-idea\" data-v-217fd8c2><h3 data-v-217fd8c2>愿景</h3><p data-v-217fd8c2>弘扬企业社会责任，激发团队智慧⾏动，创建公平美好的社会。</p><h3 data-v-217fd8c2>资助理念</h3><p data-v-217fd8c2>沃公益重点资助“社会企业弱势员⼯”及“贫困⽣”两⼤领域。</p><div class=\"img flex\" data-v-217fd8c2><img src=\"" + _imports_1 + "\" alt=\"\" class=\"img01\" data-v-217fd8c2><img src=\"" + _imports_2 + "\" alt=\"\" class=\"img02\" data-v-217fd8c2></div></div></div>", 1);
const _hoisted_4 = {
  class: "WO-welfare-news"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "van-ellipsis"
};
const _hoisted_8 = {
  key: 0,
  class: "van-multi-ellipsis--l2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_about_tab = _resolveComponent("about-tab");
  const _component_van_list = _resolveComponent("van-list");
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _hoisted_2, _createVNode(_component_about_tab, {
    scenario: $data.scenario
  }, null, 8, ["scenario"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.data.length > 0 ? '我是有底线的' : '',
    onLoad: $options.load,
    offset: "0"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "news-list",
        key: key
      }, [_createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.actionTo('/news/' + item.newsid)
      }, [_createElementVNode("img", {
        src: item.imageUrl
      }, null, 8, _hoisted_6), _createElementVNode("h3", _hoisted_7, _toDisplayString(item.title), 1), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item.description), 1)) : _createCommentVNode("", true)], 8, _hoisted_5)]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])]), _createVNode(_component_bottom_foot)]);
}